<script setup>

import JRectItem from "@/v2/components/qrcode/rect/item/index.vue";
import JRectImage from "@/v2/components/qrcode/rect/image/index.vue";

/**
 * 參數 - 外部 - 提交
 */
const emit = defineEmits(["refresh"])

/**
 * 傳入 - 參數
 */
const props = defineProps({
    mode: { type: null, required: true },
    active: { type: Object, required: true }
  })

</script>

<template>
  <div class="s5">
    <!-- 二維碼圖 -->
    <j-rect-image :mode="props.mode"
                  :blob="props.active.blob" />
    <!-- 狀態 - 顯示 -->
    <j-rect-item @refresh="emit('refresh')"
                 :i18n="props.active.i18n"
                 :status="props.active.status" />
  </div>
</template>

<style scoped lang="scss">
.s5 {
  position: relative;
}
</style>